import { getHierarchyLevelTypeSplitEpicFromCustom } from '@atlassian/jira-issue-type-hierarchies';
import type { CardType } from '../../model/types';
import {
	loadCardCreateConfig as fetch,
	type CardCreateConfigRestResponse,
} from '../../rest/load-card-create-config';

import 'rxjs/add/operator/map';

export interface CardCreateConfig {
	cardTypes: CardType[];
}

export const transformer = (response: CardCreateConfigRestResponse): CardCreateConfig => {
	if (!response.issueTypes.successful) {
		return {
			cardTypes: [],
		};
	}

	return {
		cardTypes: response.issueTypes.values.map((issueType) => ({
			id: Number(issueType.id),
			name: issueType.name,
			iconUrl: issueType.iconUrl,
			hasRequiredFields: null,
			typeHierarchyLevel: getHierarchyLevelTypeSplitEpicFromCustom(issueType.hierarchyLevel),
		})),
	};
};

const loadCardCreateConfigService = (jqlQuery: string) => fetch(jqlQuery).map(transformer);

export default loadCardCreateConfigService;
